class WidgetCrossSell extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.cartDrawer = document.querySelector('cart-drawer');

    this.init();
  }

  init() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.fetchContents();
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 200px 0px',
    }).observe(this);
  }

  fetchContents() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const widget = html.querySelector('widget-cross-sell');
        const recommendations = widget.querySelector('[data-products-list]');
        const progress = widget.querySelector('[data-progress]');

        this.appendContents(recommendations.innerHTML);
        this.updateProgress(progress.innerHTML);

        if (!recommendations || !recommendations.innerHTML.trim().length) {
          const open = this.querySelector('[open]');

          if (open) {
            this.querySelector('summary').click();
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  appendContents(html) {
    this.querySelector('[data-products-list]').innerHTML = html;
  }

  updateProgress(html) {
    this.querySelector('[data-progress]').innerHTML = html;
  }
}

customElements.define('widget-cross-sell', WidgetCrossSell);
